export const faqData = [
  {
    id: 1,
    question: '2. el bilgisayar alırken nelere dikkat etmeliyim?',
    answer: '2. el bilgisayar alırken öncelikle cihazın genel durumunu kontrol edin. Ekran, klavye ve kasada fiziksel hasar olup olmadığına bakın. Donanım özelliklerinin ihtiyaçlarınıza uygun olduğundan emin olun. Mutlaka test edin ve garanti belgesi isteyin. ES Bilgisayar olarak tüm ikinci el bilgisayarlarımızı detaylı testlerden geçiriyoruz ve garanti veriyoruz.',
  },
  {
    id: 2,
    question: 'Bilgisayar tamiri ne kadar sürer?',
    answer: 'Bilgisayar tamiri süresi arızanın türüne göre değişir. Basit yazılım sorunları ve format atma işlemleri genellikle aynı gün içinde tamamlanır. Donanımsal arızalarda parça temini durumuna göre 1-3 gün sürebilir. Laptop tamiri ve masaüstü bilgisayar tamiri için ücretsiz ön inceleme yapıyoruz ve tahmini süreyi size bildiriyoruz.',
  },
  {
    id: 3,
    question: 'Eski bilgisayarımı ne kadara satın alırsınız?',
    answer: 'İkinci el bilgisayar alım fiyatı, cihazın markası, modeli, yaşı, donanım özellikleri ve genel durumuna göre belirlenir. Ücretsiz değerlendirme için bilgisayarınızı mağazamıza getirebilir veya WhatsApp üzerinden fotoğraf ve özelliklerini paylaşabilirsiniz. 2. el bilgisayar alışında piyasanın en uygun fiyatlarını sunuyoruz.',
  },
  {
    id: 4,
    question: 'Teknik servis garantisi var mı?',
    answer: 'Evet, tüm bilgisayar tamiri ve laptop tamiri hizmetlerimizde 12 ay garanti veriyoruz. Değiştirilen parçalar orijinal ve garantilidir. Teknik servis işlemlerimiz sonrası herhangi bir sorun yaşarsanız, garanti kapsamında ücretsiz olarak çözüm sağlıyoruz.',
  },
  {
    id: 5,
    question: 'Hangi marka bilgisayarların tamirini yapıyorsunuz?',
    answer: 'Dell, HP, Lenovo, Asus, Acer, MSI, Apple, Toshiba, Samsung ve diğer tüm markaların masaüstü bilgisayar tamiri, laptop tamiri ve notebook tamiri hizmetlerini sunuyoruz. Oyuncu bilgisayarı tamiri konusunda da uzmanız. Kurumsal bilgisayar servisi için özel paketlerimiz mevcuttur.',
  },
  {
    id: 6,
    question: 'Format atma işlemi verilerimi siler mi?',
    answer: 'Format atma işlemi bilgisayarınızdaki tüm verileri siler. Bu nedenle işlem öncesi önemli dosyalarınızın yedeğini almanızı öneririz. Dilediğiniz takdirde veri yedekleme hizmetimizden de faydalanabilirsiniz. Bilgisayar bakım ve format işlemlerinde verilerinizin güvenliği bizim için önceliklidir.',
  },
];